import { observable, computed, toJS, action, runInAction } from "mobx";
import { getParameterByName, replaceUrlParam } from "@utils/Browser";
import rootService from "../@data/service";

const { search, getService, getAccountByToken } = rootService;

class SearchStore {
	@observable showSavvySlide = false;

	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;
		this._location = staticContext.app.location;
	}

	get accountStore() {
		const { accountStore } = this.rootStore.stores;
		return accountStore;
	}

	get serviceKey() {
		return getParameterByName("service");
	}

	get midtailKey() {
		return getParameterByName("midtail");
	}

	get zipcode() {
		return getParameterByName("zipcode") || this._location?.zipcode;
	}

	get injectProId() {
		return getParameterByName("id");
	}

	@observable _location = {};
	@computed get location() {
		return toJS(this._location);
	}

	@observable _pros = [];
	@computed get pros() {
		return toJS(this._pros);
	}

	@observable _service;
	@computed get service() {
		return toJS(this._service);
	}

	@observable _midtail;
	@computed get midtail() {
		return toJS(this._midtail);
	}

	@observable _questions = [];
	@computed get questions() {
		return toJS(this._questions);
	}

	get changedService() {
		if (!this.service) return true;
		return this.serviceKey !== this.service.key;
	}

	get selectedProvider() {
		const { proListItemStore } = this.rootStore.stores;
		return proListItemStore?.selectedProvider;
	}

	@action
	reset() {
		const { searchFilterQuestionStore } = this.rootStore.stores;
		searchFilterQuestionStore.reset();
		this._pros = [];
	}

	async search({
		serviceKey,
		zipcode,
		injectProId,
		geoBound,
		answerKeyFilters,
		anonymousId,
		userId,
	} = {}) {
		try {
			const { response } = await search(
				{
					serviceKey,
					zipcode,
					answerKeyFilters,
					injectProId,
					geoBound,
					anonymousId,
					userId,
				},
				{ batch: true }
			);

			return response;
		} catch (err) {
			throw err;
		}
	}

	async redirectBasedOnAffinity() {
		try {
			const { history } = this.rootStore;
			if (this.midtailKey) {
				var midtail = await getService(
					{ filter: { key: this.midtailKey } },
					{ batch: true }
				);

				midtail.affinities = midtail?.affinities?.filter(
					(a) => !a.affinity.midtail
				);

				if (midtail?.affinities.length === 1 && !this.serviceKey)
					return history.push(
						replaceUrlParam(
							`/search${window.location.search}`,
							"service",
							midtail.affinities[0].affinity.key
						)
					);
				return midtail;
			}
		} catch (err) {
			throw err;
		}
	}

	async getAccount() {
		let account;
		if (this.injectProId) {
			try {
				account = await getAccountByToken();
			} catch (err) {}
		}
		return account;
	}

	@action
	async init() {
		try {
			const { searchFilterQuestionStore } = this.rootStore.stores;
			const selections = searchFilterQuestionStore.selection;

			const midtail = await this.redirectBasedOnAffinity();
			// const waitForSegment = () =>
			// 	new Promise((resolve) =>
			// 		analytics.ready(function () {
			// 			resolve(true);
			// 		})
			// 	);
			// await waitForSegment();
			// const user = await analytics.user();
			const { providers, filterQuestions, service, location } =
				await this.search(
					{
						serviceKey: this.serviceKey || this.midtailKey,
						zipcode: this.zipcode,
						injectProId: this.injectProId,
						answerKeyFilters: selections || [""],
						// anonymousId: user.anonymousId(),
						// userId: user.id(),
					},
					{ batch: true }
				);

			const account = await this.getAccount();
			runInAction(() => {
				this._pros = providers.map(({ provider, estimated_price }) => ({
					...provider,
					estimated_price,
				}));
				this._location = location;
				this._service = service;
				this._questions = filterQuestions;
				this._midtail = midtail;
				this.showSavvySlide =
					account?.provider?.claimed === false &&
					account.provider.track.source === "savvy";
			});
		} catch (err) {
			throw err;
		}
	}
}

export default SearchStore;
